ixModuleRouting("impactx.manualordercreation", {
    "/manualordercreation/:comId/:usrId/:cscId": {
        template: "<ixa-manual-order-creation></ixa-manual-order-creation>",
        templateUrl:
            "modules/manualordercreation/templates/manualordercreation.tmpl.html",
        controller: "ManualOrderCreationCtrl",
        controllerAs: "manualOrderCreationCtrl",
        process: "ManualOrderCreation",
        workspace: "shop",
    },
});
